/*jshint strict: false */
(
    function (window, document, $, _, undefined) {
        function updateSegments() {
            var industrySelect = $('#industry'),
                segmentSelect = $('#segment'),
                selectedIndustry = industrySelect.val();

            if (_.isEmpty(selectedIndustry)) {
                segmentSelect.attr('disabled', 'disabled')
                    .attr('aria-disabled', 'true')
                    .prop('disabled', true);
            } else {
                var optGroup = window.industrySegments.filter('[data-industry-id="' + selectedIndustry + '"]');

                if (optGroup.length > 0) {
                    segmentSelect.find('optgroup').detach();

                    segmentSelect.append(optGroup.get(0))
                        .removeAttr('disabled')
                        .attr('aria-disabled', 'false')
                        .prop('disabled', false);
                } else {
                    segmentSelect.attr('disabled', 'disabled')
                        .attr('aria-disabled', 'true')
                        .prop('disabled', true);
                }
            }
        }

        $(document).ready(
            function () {
                var industrySelect = $('#industry'),
                    segmentSelect = $('#segment');

                window.industrySegments = segmentSelect.find('optgroup').detach();

                updateSegments();

                industrySelect.on(
                    'change.one-health',
                    updateSegments
                );
            }
        );
    }
)(window, document, window.jQuery, window._);
